<template>
  <div class="login-wrap">
    <div class="login-back">
      <el-image style="height: 100%;width: 100%"
                :src="require('@/assets/images/login-bg.jpg')" fit="cover"></el-image>
    </div>
    <div class="ms-login">
      <div class="ms-title">登录</div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="ms-content">

        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名" clearable>
            <el-button slot="prepend" icon="el-icon-user"></el-button>
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            placeholder="请输入密码"
            v-model="loginForm.password"
            show-password clearable
          >
            <el-button slot="prepend" icon="el-icon-lock"></el-button>
          </el-input>
        </el-form-item>

        <div class="login-btn">
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {backManageLogin} from '../../../../../request/api'
export default {
  name: 'BackManageLogin',
  data: function () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var parma = {'username': this.loginForm.username, 'password': this.loginForm.password}

          backManageLogin(parma).then(res => {
            console.log(res)

            if (res.code === '90') {
              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
              this.$message.error(res.msg)
            }
          }).catch((error) => {
            console.log(error)
            this.$message.error(error)
          })
        } else {
          return false
        }
      })
    }

  }
}
</script>

<style scoped>
.login-wrap {
  /*position: relative;*/
  /*width: 100%;*/
  /*height: 100%;*/
  /*background-image: url(../../../../assets/img/login-bg.jpg);*/
  /*background-size: 100%;*/
}
.login-back{
  position: absolute;
  /*min-width: 10s00px;*/
  /*max-width: 1400px;*/
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  border-bottom: 1px solid #ddd;
}
.ms-login {
  position: absolute;
  left: 50%;
  top: 50%;
  /*right: 3%;*/
  width: 500px;
  height: 286px;
  margin: -143px 0 0 -250px;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.3);
  /*overflow: hidden;*/
}
.ms-content {
  padding: 30px 30px;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/login/BackManageLogin.vue